import React, { useEffect, useState } from 'react';
import { ViewRoleLayout } from './view-role.layout';
import { useParams } from 'react-router-dom';
import { DefaultOptions, useApis, useSetFetchState } from '../../../global-state';
import { RoleDto } from '../../../apis';
import { FetchStatus, FetchType } from '../../../enums/fetch';

export function RolePage(): JSX.Element {
  const { roleId } = useParams();
  const { roleApi } = useApis();
  const [role, setRole] = useState<RoleDto>();
  const setFetchState = useSetFetchState();
  useEffect(() => {
    async function getData() {
      
      setFetchState(FetchStatus.Active, FetchType.PageFetching);
      //  actions.startLoader({ path: PagePath.roleManagementCompanyRole, type: FetchType.PageFetching });
      const response = await roleApi.roleOutlineGet(roleId, DefaultOptions);
      setRole(response);
      //  actions.stopLoader(PagePath.roleManagementCompanyRole);
      setFetchState(FetchStatus.Inactive, FetchType.PageFetching);
    }
    getData();
  }, []);

  return (
    <ViewRoleLayout role={role} />
  );
}